module.exports = __webpack_public_path__ + "img/sai.873536ff.svg";